module.exports = __webpack_public_path__ + "src/img/stylemarks/laptop-0.5763d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/stylemarks/laptop-0.jpg
// module id = 115
// module chunks = 0